<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jafJPx/tc-custom/9780226288130.jpg?1722581146732" alt="This image is the cover for the book Seeking the Straight and Narrow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seeking the Straight and Narrow
      </h1>
      <p class="bookDescription body article font2">
        <p>Losing weight and changing your sexual orientation are both notoriously difficult to do successfully. Yet many faithful evangelical Christians believe that thinness and heterosexuality are godly ideals—and that God will provide reliable paths toward them for those who fall short. <i>Seeking the Straight and Narrow</i> is a fascinating account of the world of evangelical efforts to alter our strongest bodily desires. Drawing on fieldwork at First Place, a popular Christian weight-loss program, and Exodus International, a network of ex-gay ministries, Lynne Gerber explores why some Christians feel that being fat or gay offends God, what exactly they do to lose weight or go straight, and how they make sense of the program’s results—or, frequently, their lack. Gerber notes the differences and striking parallels between the two programs, and, more broadly, she traces the ways that other social institutions have attempted to contain the excesses associated with fatness and homosexuality. Challenging narratives that place evangelicals in constant opposition to dominant American values, Gerber shows that these programs reflect the often overlooked connection between American cultural obsessions and Christian ones.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lynne Gerber
      </h2>
      
      <p class="authorDescription body article"><P><B>Lynne Gerber</B> is a lecturer in the religious studies department and research fellow in the Religion, Politics, and Globalization Program at the University of California, Berkeley.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8ed390c2